// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { useCallback, useMemo } from "react";
import qs from "qs";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";

const QS_OPTIONS: qs.IParseOptions = { ignoreQueryPrefix: true };
const QS_STRINGIFY_OPTIONS: qs.IStringifyOptions = { skipNulls: true };

export function useQueryParams<T extends object>(location: any) {
    const history = useHistory();

    const params = useMemo(() => {
        return qs.parse(location.search, QS_OPTIONS) as Partial<T>;
    }, [location.search]);

    const setParams = useCallback(
        (newParams: Partial<T>) => {
            const filtered = Object.fromEntries(
                Object.entries(newParams).filter(([, value]) => value !== undefined && value !== null && value !== ""),
            );

            const queryString = qs.stringify(filtered, QS_STRINGIFY_OPTIONS);
            history.replace(`${location.pathname}${queryString ? `?${queryString}` : ""}`);
        },
        [history, location.pathname],
    );

    return [params, setParams] as const;
}
